import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.svg';
import './Navbar.css';

const links = [
  { href: '#home',    label: 'Home'     },
  { href: '#about',    label: 'About'    },
  { href: '#services', label: 'Services' },
  { href: '#staff',    label: 'Our Team' },
  { href: '#founder',  label: 'Founder'  },
  { href: '#testimonials', label: 'Reviews'},
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    if (href === '#home') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-inner">

        {/* ── Logo ── */}
        <button
          className="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          <img src={logo} alt="Akshara Learning Centre Logo" className="nav-logo-img" />
          <div className="logo-text">
            <span className="logo-main">Akshara</span>
            <span className="logo-sub">Learning Centre</span>
          </div>
        </button>

        {/* ── Desktop Links ── */}
        <div className="nav-links">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="nav-link"
              onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className="btn btn-primary nav-cta"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
          >
            Enquire Now
          </a>
        </div>

        {/* ── Hamburger ── */}
        <button
          className={`hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>

      {/* ── Mobile Menu ── */}
      {menuOpen && (
        <div className="mobile-menu">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="mobile-link"
              onClick={(e) => { e.preventDefault(); scrollTo(l.href); }}
            >
              {l.label}
            </a>
          ))}
          <a
            href="#contact"
            className="mobile-link mobile-cta"
            onClick={(e) => { e.preventDefault(); scrollTo('#contact'); }}
          >
            Enquire Now →
          </a>
        </div>
      )}
    </nav>
  );
}
